export const fmtPrice = (p) => {
  if (p == null) return "—";
  const n = Number(p);
  if (!isFinite(n) || n === 0) return "$0";
  if (n >= 1) return `$${n.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
  if (n >= 0.01) return `$${n.toFixed(4)}`;
  const decimals = Math.min(Math.max(Math.ceil(-Math.log10(n)) + 3, 4), 12);
  return `$${n.toFixed(decimals)}`;
};

export const fmtUsd = (v) => {
  if (v == null) return "—";
  const n = Number(v);
  if (!isFinite(n)) return "—";
  if (n >= 1_000_000_000) return `$${(n / 1_000_000_000).toFixed(2)}B`;
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(2)}K`;
  return `$${n.toFixed(2)}`;
};

export const fmtChange = (c) => {
  if (c == null) return null;
  const n = Number(c);
  if (!isFinite(n)) return null;
  return `${n >= 0 ? "+" : ""}${n.toFixed(2)}%`;
};
